import { useAppSelector } from '@src/store/hooks';
import { selectUsers } from '@src/store/slices/users/usersSlice';
import { getModulePermissions, getNewAbilities } from '@src/utils';
import { FC } from 'react';

interface IActionItem {
  item: any;
  idx?: number;
  dataTestId?: string;
  isLastItem?: boolean;
}

const ActionItem: FC<IActionItem> = ({
  item,
  dataTestId,
  isLastItem = false,
}) => {
  const { newPermissions } = useAppSelector(selectUsers);
  const ready = getModulePermissions(newPermissions);
  const fullData = ready.reduce(
    (acc, item) => {
      acc[item.module] = item.abilities;
      return acc;
    },
    {} as Record<string, any>
  );

  return (
    <div
      data-test-id={dataTestId}
      className={`action-wrapper ${isLastItem ? 'action-wrapper--last' : ''}`}
    >
      <div className="action-left">
        <div className="action-icon">{item.icon}</div>
        <h4 className="action-title">{item.iconText}</h4>
      </div>

      <div className="action-right">
        {item.actions.map((action: any, index: number) => {
          const moduleName = action.module || item.module;
          // permissionTab checks a single tab instead of the whole module.
          const moduleAbilities = action.permissionTab
            ? getNewAbilities(
                action.permissionTab,
                newPermissions?.find((mod: any) => mod.name === moduleName)
                  ?.permissions
              ).abilities
            : fullData[moduleName] || [];
          const canUse =
            action.isAlwaysEnabled ||
            (action.requiredAbility
              ? moduleAbilities.includes(action.requiredAbility) ||
                (action.requiredAbility === 'Create' &&
                  moduleAbilities.includes('Edit'))
              : moduleAbilities.includes('Read'));
          return (
            <button
              key={index}
              className={`${!canUse ? 'disabled' : ''}`}
              onClick={action?.actionFunction}
              disabled={!canUse}
              data-test-id={action.actionText}
            >
              {action.actionText}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ActionItem;
